import React, { useEffect, useRef } from "react"
import cx from "classnames"
import { preventBodyScroll } from "@/utils/helper"
import close from "@/public/icons/close.svg"

const Modal = ({
  closeIcon = close,
  showModal,
  customClass,
  children,
  onClose,
  closeAriaLabel = "",
  modalAriaLabel = "",
}) => {
  const modalWindow = useRef(null)
  const modalContent = useRef(null)
  const modalBody = useRef(null)
  const ModalClass = cx({ "modal-popup": true, "show-modal-popup": showModal })

  useEffect(() => {
    if (showModal) {
      window.addEventListener("keydown", handleKeyPress)
      modalWindow.current.focus()
      preventBodyScroll(true)
      document.body.setAttribute(
        "style",
        `position: fixed; top: -${window.scrollY}px; left: 0; right: 0;`
      )
    } else {
      document.body.removeAttribute("style")
      window.prevActiveElement?.focus()
      preventBodyScroll(false)
    }
    return () => {
      document.body.removeAttribute("style")
      window.removeEventListener("keydown", handleKeyPress)
    }
  }, [showModal])

  const handleKeyPress = e => {
    const focusElements =
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    const focusContent = modalWindow.current.querySelectorAll(focusElements)
    const firstElem = focusContent[1]
    const lastElem = focusContent[focusContent.length - 1]
    if (e.key === "Escape") {
      onClose()
      preventBodyScroll(false)
    }
    if (e.key === "Tab") {
      if (
        e.shiftKey &&
        (document.activeElement === firstElem ||
          document.activeElement === modalWindow.current)
      ) {
        e.preventDefault()
        lastElem.focus()
      }
      if (!e.shiftKey && document.activeElement === lastElem) {
        e.preventDefault()
        firstElem.focus()
      }
    }
  }

  const handleKeyDown = e => {
    if (e.key === "Enter") {
      e.target.click()
    }
  }

  return (
    <div
      className={`${ModalClass} ${customClass ? customClass : ""}`}
      role="dialog"
      aria-modal
      tabIndex="-1"
      ref={modalWindow}
      aria-label={modalAriaLabel ? modalAriaLabel : null}
      onFocus={handleKeyPress}
    >
      <div className="modal-popup-content" ref={modalContent}>
        <div className="close-button-holder">
          <button
            className="close-button"
            onClick={onClose}
            aria-label={closeAriaLabel}
            onKeyDown={handleKeyDown}
          >
            <img src={closeIcon.src} alt="" />
          </button>
        </div>
        <div className="modal-popup-body" ref={modalBody}>
          {showModal && children}
        </div>
      </div>
    </div>
  )
}

export default Modal
